// facilities--user-locations (CONEK-7558) — one site in the user screen's
// Locations section (Facilities::Admin::UserLocationsController).
//
// A building is only assignable together with its site, so ticking a
// building ticks its site and unticking the site clears its buildings — the
// server refuses the other combinations (Facilities::UserLocations::Sync,
// :building_without_site), and this keeps the form from offering them.
//
// The state line says what saving would mean for this site: not assigned,
// the whole site (no building ticked), or narrowed to some of its buildings.
// Its three texts are the server's, rendered as values.
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["site", "building", "state"]
  static values = { none: String, whole: String, narrowed: String }

  connect() {
    this.render()
  }

  siteChanged() {
    if (!this.siteTarget.checked) {
      this.buildingTargets.forEach((box) => {
        box.checked = false
      })
    }
    this.render()
  }

  buildingChanged(event) {
    if (event.target.checked) this.siteTarget.checked = true
    this.render()
  }

  render() {
    if (!this.hasStateTarget) return

    const total = this.buildingTargets.length
    const count = this.buildingTargets.filter((box) => box.checked).length
    let text = this.noneValue
    if (this.siteTarget.checked) {
      text =
        count === 0
          ? this.wholeValue
          : this.narrowedValue
              .replace("%{count}", String(count))
              .replace("%{total}", String(total))
    }
    this.stateTarget.textContent = text
  }
}
